import type { IHealthRepository } from "@src/domain/system/repository/health_repository";
import type { Health } from "@src/domain/system/value_objects/health";

/**
 * Get Health Use Case
 * Fetches the current system health status
 */
export class GetHealthUseCase {
    constructor(private readonly healthRepository: IHealthRepository) { }

    async execute(): Promise<Health> {
        return await this.healthRepository.getHealth();
    }
}
